import { useSelector } from 'react-redux';

import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { IS_LOCAL_ENVIROMENT } from '~/src/constants';
import { selectIsAuth } from '~/src/store/selectors/auth/selectIsAuth';

import Constructor from './Constructor';
import Context from './Ctx';

const TariffBuilder = (): JSX.Element => {
    const isAuth = useSelector(selectIsAuth);

    return (
        <Context debugMode={IS_LOCAL_ENVIROMENT}>
            <WideContainer>
                <Constructor
                    routerLimitations={{ total: 5, installment: 1 }}
                    decoderLimitations={{ total: 5, installment: 2 }}
                    withCurrent={isAuth}
                />
            </WideContainer>
        </Context>
    );
};

export default TariffBuilder;
